<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    {{data.content}}
</div>
<mat-dialog-actions align="end" class="actions w-full">
    <button class="text-base whitespace-nowrap" mat-button [mat-dialog-close]="true" cdkFocusInitial>Đồng ý</button>
    <button class="text-base whitespace-nowrap" mat-button [mat-dialog-close]="false" *ngIf="!data || data.type !== 'success'">Hủy</button>
</mat-dialog-actions>